/* eslint-disable no-useless-escape */
export const FeedbackValidator = (values, errorMessage) => {
  const errors = {};
  const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (!emailRegex.test(values)) {
    errors.feedbackEmail = errorMessage;
  }
  return errors;
};
export default FeedbackValidator;
